/*
  WHERE A PHOTOS LINK LANDS (FB-0023): our own page, go.stayoo.com/media/<code>. The seven letters are a
  short link like any other (shortLink.js); go.stayoo.com/<code> sends her here.
*/
import { ALPHABET } from '../listing/enquiryLink.js'

const MEDIA = new RegExp(`^/media/([${ALPHABET}]{7})/?$`)

export const mediaPagePath = (code) => `/media/${code}`
export const mediaCodeFromPath = (path) => (MEDIA.exec(String(path ?? '')) ?? [])[1] ?? null
